module.exports = __webpack_public_path__ + "img/cable-images.017dce87.svg";